module.exports = __webpack_public_path__ + "public/Icons/4Homepagesettings.svg?3a1ae9af";